/* Herbal Talents - Staffel-Geschenke: Auswahl in einem grossen Fenster mit allen Geschenken auf einen Blick */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, modal = null, state = { allowed: 0, have: 0 };
  function rate() { var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  function money(a) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: c }).format(a); } catch (e) { return a.toFixed(2) + ' ' + c; }
  }
  function plural(n) { return n === 1 ? 'Geschenk' : 'Geschenke'; }
  function tiers(box) {
    return box.getAttribute('data-tiers').split(',').map(function (t) {
      var p = t.split(':'); return { amount: parseFloat(p[0]) * rate(), count: parseInt(p[1], 10) || 0 };
    }).filter(function (t) { return t.amount > 0 && t.count > 0; }).sort(function (a, b) { return a.amount - b.amount; });
  }
  function refresh() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || /\/cart\/?$/.test(location.pathname)) {
      try { sessionStorage.setItem('ht-gift-reopen', modal ? '1' : ''); } catch (e) {}
      location.reload(); return new Promise(function () {});
    }
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var parser = new DOMParser();
      var fresh = s['cart-drawer'] && parser.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        var overlay = drawer.querySelector('#CartDrawer-Overlay'), host = drawer.closest('cart-drawer');
        if (overlay && host && host.close) overlay.addEventListener('click', host.close.bind(host));
      }
      var bubble = document.getElementById('cart-icon-bubble');
      var b = s['cart-icon-bubble'] && parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && b) bubble.innerHTML = b.innerHTML;
    }).catch(function () { location.reload(); });
  }
  function enforce(box, allowed) {
    var have = parseInt(box.getAttribute('data-gift-qty'), 10) || 0;
    if (have <= allowed || busy) return false;
    var lines = (box.getAttribute('data-gift-lines') || '').split(',').filter(Boolean).map(function (l) { var p = l.split(':'); return { key: p[0], qty: parseInt(p[1], 10) }; });
    var excess = have - allowed, updates = {};
    for (var i = lines.length - 1; i >= 0 && excess > 0; i--) { var take = Math.min(lines[i].qty, excess); updates[lines[i].key] = lines[i].qty - take; excess -= take; }
    busy = true;
    fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(refresh).then(function () { busy = false; });
    return true;
  }

  /* ---- grosses Auswahlfenster ---- */
  function modalText() {
    var left = state.allowed - state.have;
    return left > 0 ? 'Wähle noch <b>' + left + '</b> ' + plural(left) + ' aus (' + state.have + ' von ' + state.allowed + ' gewählt).'
                    : 'Fertig! Alle ' + state.allowed + ' ' + plural(state.allowed) + ' liegen in deinem Warenkorb.';
  }
  function openModal(box) {
    var tpl = box.querySelector('[data-ht-gift-tpl]');
    if (!tpl) return;
    closeModal();
    modal = document.createElement('div');
    modal.className = 'ht-gift-modal';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Geschenk auswählen');
    modal.innerHTML = '<div class="ht-gift-modal__overlay" data-ht-gift-close></div><div class="ht-gift-modal__box">' +
      '<button type="button" class="ht-gift-modal__x" data-ht-gift-close aria-label="Schließen">&times;</button>' +
      '<p class="ht-gift-modal__eyebrow">&#127873; Dein Geschenk</p><h2 class="ht-gift-modal__title">Such dir dein Geschenk aus</h2>' +
      '<p class="ht-gift-modal__msg" data-ht-gift-modal-msg></p><div class="ht-gift-modal__grid"></div>' +
      '<button type="button" class="ht-gift-modal__done" data-ht-gift-close>Weiter einkaufen</button></div>';
    modal.querySelector('.ht-gift-modal__grid').appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(modal);
    document.documentElement.classList.add('ht-gift-lock');
    updateModal();
    var x = modal.querySelector('.ht-gift-modal__x'); if (x) x.focus();
  }
  function updateModal() {
    if (!modal) return;
    modal.querySelector('[data-ht-gift-modal-msg]').innerHTML = modalText();
    var full = state.have >= state.allowed;
    modal.querySelectorAll('[data-ht-gift-add]').forEach(function (b) {
      if (b.hasAttribute('data-soldout')) return;
      b.disabled = full;
    });
    modal.classList.toggle('is-full', full);
  }
  function closeModal() {
    if (modal) { modal.remove(); modal = null; }
    document.documentElement.classList.remove('ht-gift-lock');
  }

  function render(box) {
    var key = box.getAttribute('data-base') + '|' + box.getAttribute('data-gift-qty');
    if (box.getAttribute('data-ht-ready') === key) return;
    box.setAttribute('data-ht-ready', key);
    box.querySelectorAll('template [data-ht-gift-add][disabled]').forEach(function (b) { b.setAttribute('data-soldout', ''); });
    var tpl = box.querySelector('[data-ht-gift-tpl]');
    if (tpl) tpl.content.querySelectorAll('[data-ht-gift-add][disabled]').forEach(function (b) { b.setAttribute('data-soldout', ''); });
    var base = parseInt(box.getAttribute('data-base'), 10) / 100;
    var have = parseInt(box.getAttribute('data-gift-qty'), 10) || 0;
    var list = tiers(box), allowed = 0, next = null;
    list.forEach(function (t) { if (base >= t.amount) allowed = Math.max(allowed, t.count); else if (!next) next = t; });
    if (!list.length) { box.hidden = true; return; }
    if (enforce(box, allowed)) return;
    state.allowed = allowed; state.have = have;
    box.querySelector('[data-ht-gift-steps]').innerHTML = list.map(function (t) {
      return '<span class="ht-gift__step' + (base >= t.amount ? ' is-reached' : '') + '">' + money(t.amount) + ' &middot; ' + t.count + ' ' + plural(t.count) + '</span>';
    }).join('');
    var text;
    if (allowed === 0) text = 'Noch <b>' + money(next.amount - base) + '</b> bis zu deinem ersten Geschenk.';
    else if (have < allowed) text = 'Du darfst <b>' + (allowed - have) + '</b> ' + plural(allowed - have) + ' auswählen (' + have + ' von ' + allowed + ' gewählt).';
    else text = 'Alle ' + allowed + ' ' + plural(allowed) + ' liegen in deinem Warenkorb.';
    if (allowed > 0 && next) text += ' Ab ' + money(next.amount) + ' darfst du ' + next.count + ' wählen.';
    box.querySelector('[data-ht-gift-msg]').innerHTML = text;
    var open = box.querySelector('[data-ht-gift-open]');
    open.hidden = !(allowed > 0 && have < allowed);
    if (modal) updateModal();
    /* neue Stufe erreicht: Fenster einmal automatisch oeffnen */
    var seenKey = 'ht-gift-seen-' + allowed, seen = null;
    try { seen = sessionStorage.getItem(seenKey); } catch (e) {}
    var reopen = null; try { reopen = sessionStorage.getItem('ht-gift-reopen'); sessionStorage.removeItem('ht-gift-reopen'); } catch (e) {}
    if (allowed > 0 && have < allowed && !modal && (!seen || reopen === '1')) {
      try { sessionStorage.setItem(seenKey, '1'); } catch (e) {}
      openModal(box);
    }
  }
  function scan() { document.querySelectorAll('[data-ht-gift]').forEach(render); }
  function currentBox() { return document.querySelector('#CartDrawer [data-ht-gift]') || document.querySelector('[data-ht-gift]'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ht-gift-open]')) { e.preventDefault(); var b = e.target.closest('[data-ht-gift]'); if (b) openModal(b); return; }
    if (e.target.closest('[data-ht-gift-close]')) { e.preventDefault(); closeModal(); return; }
    var btn = e.target.closest('[data-ht-gift-add]');
    if (!btn || busy || btn.disabled) return;
    e.preventDefault();
    busy = true; btn.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-ht-gift-add'), 10), quantity: 1, properties: { _ht_gift: '1' } }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); })
      .then(function () {
        btn.removeAttribute('aria-busy'); btn.classList.add('is-picked');
        var cta = btn.querySelector('.ht-gift__cta'); if (cta) cta.textContent = 'Gewählt ✓';
        state.have += 1; updateModal();
        return refresh();
      })
      .then(function () { busy = false; scan(); if (modal && state.have >= state.allowed) setTimeout(closeModal, 900); })
      .catch(function () { busy = false; btn.removeAttribute('aria-busy'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal) closeModal(); });

  function start() {
    scan();
    var mo = new MutationObserver(scan);
    ['CartDrawer', 'main-cart-footer', 'main-cart-items'].forEach(function (id) {
      var el = document.getElementById(id) || document.querySelector('[id*="' + id + '"]');
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
